/* eslint-disable vue/no-parsing-error */
<template>
  <a-spin :spinning="loading">
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5 v-if="onlineExamData">
            Manage questions for {{ onlineExamData.name }} online exam
          </h5>
          <h5 v-else>Online Exam Questions</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a
            href="javascript:;"
            class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <!-- Question list -->
                <div class="d-flex justify-content-between mb-2">
                  <h5>Questions</h5>
                  <!-- Question Priview -->
                  <a-tooltip placement="topLeft" title="Preview">
                    <a
                      href="javascript:;"
                      class="btn btn-sm btn-primary"
                      @click="handleQuestionPriview()"
                      style="margin-left:35%"
                    >
                      <span class="btn-addon">
                        <i class="btn-addon-icon fe fe-eye" />
                      </span>
                    </a>
                  </a-tooltip>
                  <!-- Add Question -->
                  <a-tooltip placement="topLeft" title="Add new question" v-if="pagepermission.cancreatequestion">
                    <a
                      href="javascript:;"
                      class="btn btn-sm btn-primary"
                      @click="handleAddNewQuestion()"
                    >
                      <span class="btn-addon">
                        <i class="btn-addon-icon fe fe-plus" />
                      </span>
                    </a>
                  </a-tooltip>
                  <!-- Bulk question upload -->
                  <a-tooltip placement="topLeft" title="Bulk question import" v-if="pagepermission.cancreatequestion">
                    <a
                      href="javascript:;"
                      class="btn btn-sm btn-primary"
                      @click="handleBulkUpload()"
                    >
                      <span class="btn-addon">
                        <i class="btn-addon-icon fe fe-upload" />
                      </span>
                    </a>
                  </a-tooltip>
                </div>
                <div v-show="hidden">
                <!-- need to load neo-ckeditor first to render MathML type code  -->
                <!-- so here a hidden neo-ckeditor is pre declare to render question priview MathML code -->
                <neo-ckeditor :initialValue= undefined ></neo-ckeditor>
              </div>
                <a-divider></a-divider>
                <!-- question priview modal------------------------------ -->
                <a-modal
                  :width="
                    this.settings['isMobileView']
                      ? 480
                      : this.settings['isTabletView']
                      ? 720
                      : 1080
                  "
                  v-model="showQuestion"
                  :title="onlineExamData.name"
                  onOk="handleOk"
                >
                  <div class="row" style="margin-top:1px">
                    <div class="col-md-6">
                      <a-form-item class="text-left">
                        <a-checkbox
                          :checked="includeCutOffStat"
                          :value="includeCutOffStat"
                          @change="getIncludeStat"
                        >
                        </a-checkbox
                        ><span style="color: #161537; font-weight: bold"
                          >Show correct option</span
                        >
                      </a-form-item>
                    </div>
                    <div class="col-md-6 text-right">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm btn-with-addon"
                        @click="print"
                        style="height: 32px;"
                      >
                        <span class="btn-addon">
                          <i class="btn-addon-icon fe fe-printer" />
                        </span>
                        Print
                      </button>
                    </div>
                  </div>
                  <div
                    v-infinite-scroll="handleInfiniteOnLoad"
                    class="demo-infinite-container"
                    :infinite-scroll-disabled="busy"
                    :infinite-scroll-distance="10"
                  >
                    <div title="QuestionPriviewModal" id="QuestionPriviewModal">
                      <a-spin :spinning="showQuestionLoading">
                        <!-- heading -->
                        <div class="col-md-12 text-center">
                          <h5>
                            <b>{{ user.user.school.name }}</b>
                            <br />
                          </h5>
                          <b
                            >{{ onlineExamData.name }} Examination Question
                            Preview</b
                          >
                          <br />
                          <b>
                            Date: {{ onlineExamData.date }} <br />
                            Time: {{ getTime(onlineExamData.start_time) }} -
                            {{ getTime(onlineExamData.end_time) }} <br />
                            FM: {{ onlineExamData.full_mark }} PM:
                            {{ onlineExamData.pass_mark }}
                          </b>
                        </div>
                        <!-- content body of question -->
                        <div
                          class="col-md-12"
                          v-if="onlineExamTypeCode !== 'NEET'"
                        >
                          <div
                            v-for="(examQues,
                            index) in onlineExamData.exam_subjects"
                            :key="index"
                          >
                            <hr />
                            <div class="text-center">
                              <b>{{ examQues.subject.name }}</b>
                            </div>
                            <hr />
                            <template v-if="onlineExamQuestions">
                              <div
                                v-for="(queData, index) in getQuestionData(
                                  onlineExamQuestions,
                                  examQues
                                )"
                                :key="index"
                              >
                                <div class="row" style="margin-right:-46px">
                                  <div
                                    class="col-sm-1"
                                    style="max-width:7.333333%"
                                  >
                                    <!-- question -->
                                    <b> Q {{ queData.question_no }}. </b>
                                  </div>
                                  <div
                                    class="col-sm-9 text-left"
                                    style="font-weight:bold"
                                  >
                                    <span v-html="queData.question"></span>
                                  </div>
                                  <div
                                    class="col-sm-2 text-right"
                                    style="max-width:15.6667%;"
                                  >
                                    <i>{{ queData.mark }} Mark</i>
                                  </div>
                                </div>
                                <!-- options -->
                                <table style="margin-left:73px">
                                  <tr
                                    v-for="(optionData,
                                    index) in queData.options"
                                    :key="index"
                                  >
                                    <th>
                                      <b>{{ alphabeticalOrder[index] }}.</b>
                                    </th>
                                    <th>
                                      <span v-html="optionData.value"></span>
                                    </th>
                                    <th v-if="includeCutOffStat">
                                      <a-icon
                                        v-if="optionData.correct === 1"
                                        type="check-circle"
                                        theme="twoTone"
                                        two-tone-color="#52c41a"
                                      />
                                    </th>
                                    <th v-else></th>
                                  </tr>
                                </table>

                                <br />
                              </div>
                            </template>
                          </div>
                        </div>
                        <div
                          class="col-md-12"
                          v-if="onlineExamTypeCode === 'NEET'"
                        >
                          <div
                            v-for="(examQues,
                            index) in onlineExamData.exam_subjects"
                            :key="index"
                          >
                            <hr />
                            <div class="text-center">
                              <b>{{ examQues.subject.name }}</b>
                            </div>
                            <hr />
                            <p>
                              <span style="font-weight:bold">Section-A</span>
                            </p>
                            <!--start Section A -->
                            <template v-if="onlineExamQuestions">
                              <div
                                v-for="(queData,
                                index) in getSubSecAQuestionData(
                                  onlineExamQuestions,
                                  examQues
                                )"
                                :key="index"
                              >
                                <div class="row" style="margin-right:-46px">
                                  <div
                                    class="col-sm-1"
                                    style="max-width:7.333333%"
                                  >
                                    <!-- question -->
                                    <b> Q {{ queData.question_no }}. </b>
                                  </div>
                                  <div
                                    class="col-sm-9 text-left"
                                    style="font-weight:bold"
                                  >
                                  <!-- {{ this.WiritizeText(queData.question) }} -->
                                    <span v-html="renderMathTag(queData.question)"></span>
                                  </div>
                                  <div
                                    class="col-sm-2 text-right"
                                    style="max-width:15.6667%;"
                                  >
                                    <i>{{ queData.mark }} Mark</i>
                                  </div>
                                </div>
                                <!-- options -->
                                <table style="margin-left:73px">
                                  <tr
                                    v-for="(optionData,
                                    index) in queData.options"
                                    :key="index"
                                  >
                                    <th>
                                      <b>{{ alphabeticalOrder[index] }}.</b>
                                    </th>
                                    <th>
                                      <!-- <span v-html="optionData.value"></span> -->
                                      <span v-html="renderMathTag(optionData.value)"></span>
                                    </th>
                                    <th v-if="includeCutOffStat">
                                      <a-icon
                                        v-if="optionData.correct === 1"
                                        type="check-circle"
                                        theme="twoTone"
                                        two-tone-color="#52c41a"
                                      />
                                    </th>
                                    <th v-else></th>
                                  </tr>
                                </table>

                                <br />
                              </div>
                            </template>
                            <!--end Section A -->
                            <p>
                              <span style="font-weight:bold">Section-B</span>
                            </p>
                            <!--start Section B -->
                            <template v-if="onlineExamQuestions">
                              <div
                                v-for="(queData,
                                index) in getSubSecBQuestionData(
                                  onlineExamQuestions,
                                  examQues
                                )"
                                :key="index"
                              >
                                <div class="row" style="margin-right:-46px">
                                  <div
                                    class="col-sm-1"
                                    style="max-width:7.333333%"
                                  >
                                    <!-- question -->
                                    <b> Q {{ queData.question_no }}. </b>
                                  </div>
                                  <div
                                    class="col-sm-9 text-left"
                                    style="font-weight:bold"
                                  >
                                    <span v-html="renderMathTag(queData.question)"></span>
                                  </div>
                                  <div
                                    class="col-sm-2 text-right"
                                    style="max-width:15.6667%;"
                                  >
                                    <i>{{ queData.mark }} Mark</i>
                                  </div>
                                </div>
                                <!-- options -->
                                <table style="margin-left:73px">
                                  <tr
                                    v-for="(optionData,
                                    index) in queData.options"
                                    :key="index"
                                  >
                                    <th>
                                      <b>{{ alphabeticalOrder[index] }}.</b>
                                    </th>
                                    <th>
                                      <!-- <span v-html="optionData.value"></span> -->
                                      <span v-html="renderMathTag(optionData.value)"></span>
                                    </th>
                                    <th v-if="includeCutOffStat">
                                      <a-icon
                                        v-if="optionData.correct === 1"
                                        type="check-circle"
                                        theme="twoTone"
                                        two-tone-color="#52c41a"
                                      />
                                    </th>
                                    <th v-else></th>
                                  </tr>
                                </table>

                                <br />
                              </div>
                            </template>
                          </div>
                        </div>
                      </a-spin>
                    </div>
                  </div>
                </a-modal>
                <!-- end modal question priview--------------------------------- -->
                <div class="mt-2" v-if="onlineExamData">
                  <a-spin :spinning="questionSpinning">
                    <div v-if="onlineExamData.exam_subjects.length > 0">
                      <div
                        v-for="onlineExamSubject in onlineExamQuestionSubjectwise(
                          onlineExamData.exam_subjects,
                          onlineExamQuestionIds
                        )"
                        :key="onlineExamSubject.id"
                      >
                        <div class="font-weight-bold mb-2">
                          {{ onlineExamSubject.subject.name }}
                        </div>
                        <template
                          v-for="(question,
                          index) in onlineExamSubject.questionIds"
                        >
                          <a
                            href="javascript:;"
                            :key="index"
                            :class="[
                              'btn btn-sm mr-2 mb-2',
                              question === selectedQuestionId
                                ? 'btn-primary'
                                : 'btn-light'
                            ]"
                            style="min-width: 2.5rem;"
                            @click="handleQuestionSelect(question)"
                          >
                            <span class="btn-addon">
                              {{ getExamQUesNo(question) }}
                            </span>
                          </a>
                        </template>
                      </div>
                    </div>
                    <div v-else>
                      <template
                        v-for="(question, index) in onlineExamQuestionIds"
                      >
                        <a
                          href="javascript:;"
                          :key="question"
                          :class="[
                            'btn btn-sm mr-2 mb-2',
                            question.id === selectedQuestionId
                              ? 'btn-primary'
                              : 'btn-light'
                          ]"
                          style="min-width: 2.5rem;"
                          @click="handleQuestionSelect(question.id)"
                        >
                          <span class="btn-addon">
                            {{ index + 1 }}
                          </span>
                        </a>
                      </template>
                    </div>
                  </a-spin>
                </div>
              </div>
              <div class="col-md-9 border-left" v-if="pagepermission.canviewquestion">
                <a-spin :spinning="questionLoading">
                  <!-- Question form -->
                  <div v-if="addNew || selectedQuestionId">
                    <div>
                      <h5 class="mb-0" v-if="selectedQuestionId">
                        View/update question
                      </h5>
                      <h5 class="mb-0" v-else>Add new question</h5>
                    </div>

                    <a-divider class="my-2" />

                    <a-form class="mb-4" :form="form">
                      <div class="row">
                        <!-- Q no. -->
                        <div class="col-md-2 mb-2">
                          <a-form-item label="Q No.">
                            <a-input-number
                              v-decorator="[
                                `question_no`,
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: 'Question no. is required'
                                    }
                                  ]
                                }
                              ]"
                              :min="1"
                              :max="10000"
                              placeholder="Q. No."
                              style="width:100%;"
                            />
                          </a-form-item>
                        </div>
                        <!-- Select Subject -->
                        <div class="col-md-3 mb-2">
                          <a-form-item label="Subject">
                            <a-select
                              v-decorator="[
                                'subject_id',
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: 'Please select a subject!!'
                                    }
                                  ],
                                  initialValue: undefined
                                }
                              ]"
                              placeholder="Select subject"
                            >
                              <a-select-option :value="undefined">
                                Select subject
                              </a-select-option>
                              <template v-for="examSubject in subjects">
                                <a-select-option
                                  :value="examSubject.id"
                                  :key="examSubject.id"
                                >
                                  {{ examSubject.name }} ({{
                                    examSubject.abbreviation
                                  }})
                                </a-select-option>
                              </template>
                            </a-select>
                          </a-form-item>
                        </div>
                        <!-- Sub Section -->
                        <div
                          class="col-md-2 mb-2"
                          v-if="onlineExamTypeCode === 'NEET'"
                        >
                          <a-form-item label="Sub-Section">
                            <a-select
                              v-decorator="[
                                'sub_section',
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: 'Please select a sub-section!!'
                                    }
                                  ],
                                  initialValue: undefined
                                }
                              ]"
                              placeholder="sub-section"
                            >
                              <a-select-option :value="undefined">
                                Select sub-section
                              </a-select-option>
                              <template v-for="examSubSections in subSections">
                                <a-select-option
                                  :value="examSubSections.value"
                                  :key="examSubSections.id"
                                >
                                  {{ examSubSections.name }}
                                </a-select-option>
                              </template>
                            </a-select>
                          </a-form-item>
                        </div>
                        <!-- Mark -->
                        <div class="col-md-2 mb-2">
                          <a-form-item label="Mark">
                            <a-input-number
                              v-decorator="[
                                `mark`,
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: 'Please input full mark'
                                    }
                                  ],
                                  initialValue: getQuestionWiseMark
                                }
                              ]"
                              :min="1"
                              placeholder="Mark"
                              style="width:100%;"
                            />
                          </a-form-item>
                        </div>
                        <!-- Is entry -->
                        <div class="col-md-2 mb-2">
                          <a-form-item label="Is entry">
                            <a-select
                              v-decorator="[
                                'is_entry',
                                { rules: [{ required: true }], initialValue: 0 }
                              ]"
                            >
                              <a-select-option :value="0">No</a-select-option>
                              <a-select-option :value="1">Yes</a-select-option>
                            </a-select>
                          </a-form-item>
                        </div>
                        <!-- Has or Question -->
                        <div class="col-md-2 mb-2">
                          <a-form-item label="Has 'Or' questions">
                            <a-select
                              v-decorator="[
                                'has_or_question',
                                { rules: [{ required: true }], initialValue: 0 }
                              ]"
                            >
                              <a-select-option :value="0">No</a-select-option>
                              <a-select-option :value="1">Yes</a-select-option>
                            </a-select>
                          </a-form-item>
                        </div>
                      </div>
                    </a-form>

                    <div v-if="addNew || editQuestion">
                      <template v-if="!form.getFieldValue('has_or_question')">
                        <question-form
                          :questionId="selectedQuestionId"
                          :onlineExamData="onlineExamData"
                          :questionData="editQuestion"
                          :questionLoading="questionLoading"
                          :isEntry="form.getFieldValue('is_entry')"
                          @updated="handleQuestionUpdate"
                          :key="formKey"
                        />
                      </template>

                      <template v-if="form.getFieldValue('has_or_question')">
                        <div
                          v-for="(orQuestion, index) in orQuestions"
                          :key="orQuestion.id"
                        >
                          <div v-if="index > 1" class="text-center mb-2">
                            <a
                              href="javascript:;"
                              class="btn btn-danger"
                              @click="handleRemoveOrQuestion(orQuestion.id)"
                            >
                              <span class="btn-addon">
                                <i class="btn-addon-icon fe fe-trash" />
                                Remove Question
                              </span>
                            </a>
                          </div>
                          <QuestionForm
                            :formId="orQuestion.id"
                            :questionId="selectedQuestionId"
                            :onlineExamData="onlineExamData"
                            :questionData="orQuestion"
                            :questionLoading="questionLoading"
                            :isEntry="form.getFieldValue('is_entry')"
                            @updated="handleQuestionUpdate"
                          />

                          <template v-if="index < orQuestions.length - 1">
                            <a-divider />
                            <div
                              class="text-center font-weight-bold py-2 h3 mb-0 bg-dark text-light"
                            >
                              Or
                            </div>
                            <a-divider class="mb-4" />
                          </template>
                          <div
                            v-if="index === orQuestions.length - 1"
                            class="py-4 text-center bg-light"
                          >
                            <a
                              href="javascript:;"
                              class="btn btn-primary"
                              @click="
                                handleAddOrQuestion(
                                  Math.floor(Math.random() * 10000)
                                )
                              "
                            >
                              <span class="btn-addon">
                                <i class="btn-addon-icon fe fe-plus" />
                                Add another Question
                              </span>
                            </a>
                          </div>
                        </div>
                      </template>

                      <a-divider class="mb-3" />

                      <div>
                        <a
                          href="javascript:;"
                          class="btn btn-success btn-with-addon mr-2"
                          @click="handleSave(true)"
                        >
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-save" />
                          </span>
                          Save question & add to Question Bank
                        </a>
                        <a
                          href="javascript:;"
                          class="btn btn-primary btn-with-addon"
                          @click="handleSave(false)"
                        >
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-save" />
                          </span>
                          Save question
                        </a>
                        <a
                          v-if="selectedQuestionId"
                          href="javascript:;"
                          class="btn btn-danger btn-with-addon float-right"
                          @click="handleDelete"
                        >
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-trash" />
                          </span>
                          Delete question
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-center"
                    style="min-height:75vh;"
                    v-else
                  >
                    <div class="text-center" v-if="pagepermission.cancreatequestion">
                      <!-- bulk question upload -->
                      <a-tooltip
                        placement="topLeft"
                        title="Bulk question import"
                      >
                        <a
                          href="javascript:;"
                          class="btn btn-primary btn-with-addon"
                          @click="handleBulkUpload()"
                          style="margin-right:5px"
                        >
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-upload" />
                          </span>
                          Bulk question upload
                        </a>
                      </a-tooltip>
                      <!-- add question -->
                      <a-tooltip placement="topLeft" title="Add new question">
                        <a
                          href="javascript:;"
                          class="btn btn-primary btn-with-addon"
                          @click="handleAddNewQuestion()"
                        >
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-plus" />
                          </span>
                          New question
                        </a>
                      </a-tooltip>

                      <p class="mt-2">
                        or click on a question number to view/edit existing
                        question.
                      </p>
                    </div>
                    <!-- bulk upload from -->
                    <!-- <a-modal
                      v-model="this.visible"
                      title="Bulk question import"
                      :width="680"
                      style="top: 20px;"
                      @cancel="handleCancel"
                      onOk="closeModal"
                    >
                      <p>ok</p> -->
                    <!-- <template slot="footer">
                        <a-button key="back" @click="handleBulkModalCancel"
                          >Cancel</a-button
                        >
                        <a-button
                          key="submit"
                          type="primary"
                          :loading="loading"
                          @click="handleSubmit"
                          >Upload</a-button
                        >
                      </template>

                      <a-form :form="form">
                        <p class="mt-3 mb-0">
                          Download the CSV file format here.
                          <a
                            href="/resources/csv/neoskool_onlineexam_bulk_question_import.csv"
                            class="btn btn-sm btn-primary btn-with-addon mx-3"
                          >
                            <span class="btn-addon">
                              <i class="btn-addon-icon fe fe-download" />
                            </span>
                            Download CSV
                          </a>
                          <span class="font-weight-bold text-warning"
                            >Fields marked with * are required!</span
                          >
                        </p>
                        <div class="row">
                          <div class="col-md-4">
                            <a-form-item label="CSV File">
                              <a-upload
                                v-decorator="[
                                  'file',
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message:
                                          'Please select a csv file to upload!'
                                      }
                                    ]
                                  }
                                ]"
                                accept=".csv, application/vnd.ms-excel, text/csv"
                                :fileList="fileList"
                                :multiple="false"
                                :remove="handleRemove"
                                :beforeUpload="beforeUpload"
                                :disabled="uploadDisabled"
                              >
                                <a-button v-if="!uploadDisabled">
                                  <a-icon type="upload" /> Select File
                                </a-button>
                              </a-upload>
                            </a-form-item>
                          </div>
                        </div>
                      </a-form> -->
                    <!-- </a-modal> -->
                    <a-modal v-model="visible" title="Bulk question import" on-ok="handleOk" :width="680" style="top: 20px;">
                      <template slot="footer">
                        <a-button key="back" @click="handlBulkModelClose">
                          Cancel
                        </a-button>
                        <a-button
                          key="submit"
                          type="primary"
                          :loading="loading"
                          @click="handleSubmit"
                        >
                          Upload
                        </a-button>
                      </template>
                      <a-form :form="form">
                        <p class="mt-3 mb-0">
                          Download the CSV file format here.
                          <a
                            href="/resources/csv/neoskool_onlineexam_bulk_question_import.csv"
                            class="btn btn-sm btn-primary btn-with-addon mx-3"
                          >
                            <span class="btn-addon">
                              <i class="btn-addon-icon fe fe-download" />
                            </span>
                            Download CSV
                          </a>
                          <span class="font-weight-bold text-warning"
                            >Fields marked with * are required!</span
                          >
                        </p>
                        <div class="row">
                          <div class="col-md-4">
                            <a-form-item label="CSV File">
                              <a-upload
                                v-decorator="[
                                  'file',
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message:
                                          'Please select a csv file to upload!'
                                      }
                                    ]
                                  }
                                ]"
                                accept=".csv, application/vnd.ms-excel, text/csv"
                                :fileList="fileList"
                                :multiple="false"
                                :remove="handleRemove"
                                :beforeUpload="beforeUpload"
                                :disabled="uploadDisabled"
                              >
                                <a-button v-if="!uploadDisabled">
                                  <a-icon type="upload" /> Select File
                                </a-button>
                              </a-upload>
                            </a-form-item>
                          </div>
                        </div>
                      </a-form>
                    </a-modal>
                  </div>
                </a-spin>
              </div>
              <div class="col-md-9 border-left">
                <div class="error">
                  <p>You dont have enough permission to view this data.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import NeoCkeditor from '@/components/ckeditor'
import { mapState } from 'vuex'
import QuestionForm from '@/components/online-exam/question/Form/index'
import { WiritizeText } from './wirisGeneric'
import moment from 'moment'
// import { debounce } from 'lodash'
const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}
export default {
  components: {
    QuestionForm,
    NeoCkeditor,
  },
  mounted: function() {
    this.getOnlineExam()
    this.contents = WiritizeText(this.x)
    this.pagepermission = this.$route.params.pagepermission
    console.log('permissions for questions.....', this.pagepermission)
  },
  created() {
    // this.searchStudents = debounce(this.searchStudents, 500)
  },
  computed: {
    ...mapState(['settings']),
    ...mapState(['user']),
    onlineExamId: function() {
      return this.$route.params.examId
    },
    getClassId: function() {
      return this.$route.params.classId
    },
    getSecId: function() {
      return this.$route.params.sectionId
    },
    getType: function() {
      return this.$route.params.examType
    },
    getQuestionWiseMark: function() {
      return this.$route.params.questionWiseMark
    },
  },
  watch: {
    onlineExamTypeCode: function(value) {
      return value
    },
    getIncludeStat: function(value) {
      return value
    },
    onlineExamQuestions: function(value) {
      return value
    },
    showQuestion: function(value) {
      // this.getQuestion()
      return value
    },
    editQuestion: function(value) {
      if (value) {
        this.form.setFieldsValue({
          subject_id: value.subject_id,
          question_no: value.question_no,
          sub_section: value.sub_section,
          mark: value.mark,
          is_entry: value.is_entry,
          has_or_question: value.has_or_question,
        })
      } else {
        this.form.resetFields()
      }
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      x: '<p><math xmlns="http://www.w3.org/1998/Math/MathML"><msqrt><mn>2</mn></msqrt></math></p>',
      contents: '',
      onlineExamTypeCode: undefined,
      alphabeticalOrder: ['a', 'b', 'c', 'd', 'e', 'f', 'g'],
      loading: false,
      questionSpinning: false,
      onlineExamData: null,
      onlineExamQuestionIds: [],
      subjects: [],
      subjectSpinning: false,
      selectedQuestionId: null,
      addNew: false,
      formKey: this._uid + Math.floor(Math.random() * 10000),
      hasOrQuestion: 0,
      defaultOrQuestions: [
        { id: Math.floor(Math.random() * 10000) },
        { id: Math.floor(Math.random() * 10000) },
      ],
      orQuestions: [
        { id: Math.floor(Math.random() * 10000) },
        { id: Math.floor(Math.random() * 10000) },
      ],
      editQuestion: null,
      questionLoading: false,
      questionData: null,
      showQuestion: false,
      onlineExamQuestions: [],
      showQuestionLoading: false,
      includeCutOffStat: true,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      busy: false,
      pagepermission: {},
      subSections: [
        { name: 'A', value: 'A' },
        { name: 'B', value: 'B' },
      ],
    }
  },
  methods: {
    renderMathTag(val) {
      let result = WiritizeText(val)
      return result
    },
    getExamQUesNo(id) {
      if (this.onlineExamQuestions.length !== 0 && id !== null) {
        // const data = this.onlineExamQuestions.sort(function(a, b) {
        //   return a.question_no - b.question_no
        // })
        const result = this.onlineExamQuestions.filter(
          obj => obj.id === id && obj.question_no !== null
        )
        if (result.length !== 0) {
          return result[0].question_no
        } else {
          return 'NA'
        }
      } else {
        return 'NA'
      }
    },
    getQuestionData(subList, subId) {
      if (subList.length !== 0 && Object.keys(subId).length !== 0) {
        const result = subList.filter(
          obj => obj.subject_id === subId.subject_id
        )
        return result
      }
    },
    getSubSecAQuestionData(subList, subId) {
      if (subList.length !== 0 && Object.keys(subId).length !== 0) {
        const result = subList.filter(
          obj => obj.subject_id === subId.subject_id
        )
        if (result.length !== 0) {
          const subSecAsubList = result.filter(obj => obj.sub_section === 'A')
          return subSecAsubList
        }
      }
    },
    getSubSecBQuestionData(subList, subId) {
      if (subList.length !== 0 && Object.keys(subId).length !== 0) {
        const result = subList.filter(
          obj => obj.subject_id === subId.subject_id
        )
        if (result.length !== 0) {
          const subSecAsubList = result.filter(obj => obj.sub_section === 'B')
          return subSecAsubList
        }
      }
    },
    handleInfiniteOnLoad() {
      const data = this.data
      this.loading = true
      if (data.length > 14) {
        this.$message.warning('Infinite List loaded all')
        this.busy = true
        this.loading = false
        return
      }
      this.fetchData(res => {
        this.data = data.concat(res.results)
        this.loading = false
      })
    },
    handleBulkModalCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
    handleBulkUpload() {
      this.addNew = false
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload(file) {
      const isCSV =
        file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    getIncludeStat(e) {
      this.includeCutOffStat = e.target.checked
    },
    getTime(timeDetails) {
      const hour = moment(timeDetails, 'hh:mm:ss').hours()
      const min = moment(timeDetails, 'hh:mm:ss').minutes()
      if (hour > 12) {
        const getMax = hour - 12
        const getRealHour = getMax
        return getRealHour + ':' + min + ' PM'
      } else {
        return hour + ':' + min + ' AM'
      }
    },
    print() {
      this.$htmlToPaper('QuestionPriviewModal')
    },
    getQuestion() {
      this.showQuestionLoading = true
      this.$http
        .get('/api/question/all/' + this.onlineExamId)
        .then(({ data }) => {
          this.onlineExamQuestions = data.data
          // this.getSchool(this.onlineExamData.school_id)
          this.showQuestionLoading = false
        })
        .catch(error => {
          this.showQuestionLoading = false
          this.$neoNotify.error(error)
        })
    },
    handleQuestionPriview() {
      this.showQuestion = true
    },
    handleCancel() {
      this.showQuestion = false
    },
    handlBulkModelClose(e) {
      this.visible = false
    },
    handleQuestionUpdate(value) {
      if (this.form.getFieldValue('has_or_question')) {
        this.orQuestions = this.orQuestions.map(function(question) {
          if (question.id === value.id) {
            question = value.questionData
            question.id = value.id
          }
          return question
        })
      } else {
        this.orQuestions = this.defaultOrQuestions
        this.questionData = value.questionData
      }
    },
    getSchool(id) {
      this.questionSpinning = true
      this.$http
        .get(`/api/school/${id}`)
        .then(({ data }) => {
          this.schoolData = data.data
          this.questionSpinning = false
        })
        .catch(error => {
          this.questionSpinning = false
          this.$neoNotify.error(error)
        })
    },
    getOnlineExam: function() {
      this.questionSpinning = true
      this.$http
        .get(`/api/online-exam/${this.onlineExamId}`)
        .then(({ data }) => {
          this.onlineExamTypeCode = data.data.exam_type_code
          this.onlineExamData = data.data
          this.questionSpinning = false
          this.getExamQuestions()
          this.getQuestion()
          this.getSubjects()
        })
        .catch(error => {
          this.questionSpinning = false
          this.$neoNotify.error(error)
        })
    },
    getExamQuestions: function() {
      this.loading = true
      this.$http
        .get(`/api/online-exam/question-ids/${this.onlineExamId}`)
        .then(({ data }) => {
          this.onlineExamQuestionIds = data.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    onlineExamQuestionSubjectwise(examSubjects, onlineExamQuestionIds) {
      return examSubjects.map(function(examSubject) {
        return {
          subject: examSubject.subject,
          questionIds: onlineExamQuestionIds
            .filter(question => question.subject.id === examSubject.subject.id)
            .map(question => question.id),
          // .sort((a, b) => a - b),
        }
      })
    },
    handleQuestionSelect: function(questionId) {
      this.selectedQuestionId = questionId
      this.addNew = false
      this.editQuestion = null
      this.questionLoading = true
      this.questionData = null
      this.$http
        .get(`/api/question/${questionId}`)
        .then(({ data }) => {
          if (data.data.has_or_question) {
            this.orQuestions = data.data.or_questions
          }
          this.editQuestion = data.data
          this.questionLoading = false
        })
        .catch(error => {
          console.log(error)
          this.questionLoading = false
        })
    },
    handleAddNewQuestion: function() {
      this.selectedQuestionId = null
      this.editQuestion = null
      this.questionData = null
      this.formKey += 1
      this.addNew = true
    },
    handleRemoveOrQuestion: function(questionId) {
      this.orQuestions = this.orQuestions.filter(function(question) {
        return question.id !== questionId
      })
    },
    getSubjects() {
      if (this.onlineExamData.exam_subjects.length > 0) {
        this.subjects = this.onlineExamData.exam_subjects.map(function(
          examSubject
        ) {
          return examSubject.subject
        })
      } else {
        this.subjectSpinning = true
        this.$http
          .get(`/api/subject/class/${this.onlineExamData.class_id}`, {
            params: {
              session_id: this.onlineExamData.session_id,
            },
          })
          .then(({ data }) => {
            this.subjects = data.data.all
            this.subjectSpinning = false
          })
          .catch(error => {
            console.log(error)
            this.subjectSpinning = false
          })
      }
    },
    handleAddOrQuestion(questionId) {
      this.orQuestions.push({ id: questionId })
    },
    handleSave: function(addToQuestionBank) {
      // this.loading = true

      if (this.selectedQuestionId) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$confirm({
              title: `Are you sure?`,
              content: `Click on the OK button to update the question!`,
              onOk: () => {
                const questionData = this.makeQuestionFormData(
                  values,
                  addToQuestionBank
                )
                const CurrentQuestionOptions = questionData.options
                const checkCurrectAnsContent = CurrentQuestionOptions.filter(
                  obj => obj.correct === true
                )
                if (checkCurrectAnsContent.length >= 1) {
                  this.$http
                    .post(
                      '/api/question/' + this.selectedQuestionId,
                      questionData
                    )
                    .then(() => {
                      this.loading = false
                      this.visible = false
                      this.$notification['success']({
                        message: 'Successfully edited',
                        description: 'Question updated successfully!',
                      })
                      this.getOnlineExam()
                      this.getExamQuestions()
                    })
                    .catch(error => {
                      this.loading = false
                      this.$neoNotify.error(error)
                    })
                } else {
                  this.$message.warning('No correct option selected!')
                }
              },
              onCancel: () => {
                this.loading = false
              },
            })
          }
        })
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            // ........
            this.$confirm({
              title: `Are you sure?`,
              content: `Click on the OK button to add the question!`,
              onOk: () => {
                const questionData = this.makeQuestionFormData(
                  values,
                  addToQuestionBank
                )
                const CurrentQuestionOptions = questionData.options
                const checkCurrectAnsContent = CurrentQuestionOptions.filter(
                  obj => obj.correct === true
                )
                if (checkCurrectAnsContent.length >= 1) {
                  this.$http
                    .post(`/api/question/create`, questionData)
                    .then(() => {
                      this.$emit('saved')
                      this.loading = false
                      this.visible = false
                      this.addNew = false
                      this.$notification['success']({
                        message: 'Successfully saved',
                        description: 'Question saved successfully!',
                      })
                      this.getOnlineExam()
                      this.getExamQuestions()
                    })
                    .catch(error => {
                      this.loading = false
                      this.$neoNotify.error(error)
                    })
                } else {
                  this.$message.warning('No correct option selected!')
                }
              },
              onCancel: () => {
                this.loading = false
              },
            })
            // .......
          }
        })
      }
    },
    makeQuestionFormData(values, addToQuestionBank) {
      if (values.has_or_question === 0) {
        return {
          class_id: this.onlineExamData.class_id,
          section_id: this.onlineExamData.section_id,
          subject_id: values.subject_id,
          online_exam_id: this.onlineExamData.id,
          // question: this.question,
          question: this.questionData.question,
          description: this.questionData.description,
          instruction: this.questionData.instruction,
          question_no: values.question_no,
          sub_section: values.sub_section,
          mark: values.mark,
          is_entry: values.is_entry,
          has_or_question: values.has_or_question,
          add_to_question_bank: addToQuestionBank ? 1 : 0,
          options: this.questionData.options,
        }
      }
      if (values.has_or_question === 1) {
        let data = {
          class_id: this.onlineExamData.class_id,
          section_id: this.onlineExamData.section_id,
          subject_id: values.subject_id,
          online_exam_id: this.onlineExamData.id,
          mark: values.mark,
          is_entry: values.is_entry,
          has_or_question: values.has_or_question,
          add_to_question_bank: addToQuestionBank ? 1 : 0,
        }
        let orQuestions = this.orQuestions.map(function(question) {
          return {
            question: question.question,
            description: question.description,
            instruction: question.instruction,
            options: question.options,
          }
        })
        data.or_questions = orQuestions
        return data
      }
    },
    handleDelete: function() {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this question!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/question/' + this.selectedQuestionId)
            .then(() => {
              this.$nprogress.done()
              this.selectedQuestionId = null
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Question has been deleted.',
              })
              this.getExamQuestions()
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleBackButton() {
      this.$router.push({ name: 'manageonlineexam' })
    },
    // upload Bulk question
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to bulk upload students marks!`,
            onOk: () => {
              values.class_id = this.getClassId
              values.section_id = this.getSecId
              values.online_exam_id = this.onlineExamId
              let formData = window.jsonToFormData(values, options)

              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/question/bulk/import', formData)
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Questions uploaded!',
                    description: `Bulk online exam questions import completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.getExamQuestions()
                  this.getOnlineExam()
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>
<style>
p {
  margin-top: 0;
  margin-bottom: 0rem;
}
.ant-modal-body {
  padding: 24px;
  font-size: 15px;
  line-height: 1.5;
  word-wrap: break-word;
  padding-top: 8px;
}
th {
  margin-top: 0;
  margin-bottom: 0;
}
.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 500px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
figure img {
  vertical-align: middle;
  border-style: none;
  width: inherit;
}
.error { padding: 25px; }
</style>
